import {withStyles} from '@material-ui/core';
import {List} from 'react-admin';
import {styles} from './styles';

export default withStyles(styles)(List);
